.container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    min-height: 400px;
    gap: 8px;
    text-align: center;
}

.code {
    margin: 4px 0 0;
}

.message {
    font-size: 14px;
    margin: 0 0 12px;
}
